import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetTimeZone } from '../../components/common/DateTimeFormatter';
import './ShopMonitorTab.css';
import tab1 from '../../assets/tab1.png';
import tab2 from '../../assets/tab2.png';
import tab3 from '../../assets/tab3.png';
import anniversary from '../../assets/anniversary-thumb.png';
import events from '../../assets/events-thumb.png';
import tab7 from '../../assets/installed-projects.png';
import tab8 from '../../assets/tab8.png';
import tab9 from '../../assets/tab9.png';
import tab10 from '../../assets/tab10.png';
import celebrate from '../../assets/celebrate.png';
import welcome from '../../assets/welcome-thumb.png';
import retirement from '../../assets/retirement.png';
import tabYtd from '../../assets/YTD_bonus_slider_graphic.png';
import { getEmployeeWorkAnniversaries } from '../../store/employee/actions';
import { getTodayEvents, getEvents } from '../../store/events/actions';
import { getProjects } from '../../store/projects/actions';
import Slider from "react-slick";
import { useNavigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isVimeoVideoExists } from '../../helpers/formatterHelper';
import { getVimeoToken } from '../../api/docCenterApi';
import { getMarketPlace } from '../../store/marketPlace/actions';
import { getContestList } from '../../store/contest/actions';
import { getNews } from '../../store/news/actions';
import { getJobPostingsByFilter } from '../../store/hrbenefits/actions';

import { GestureRecognizer, FilesetResolver } from '@mediapipe/tasks-vision';

export const ShopMonitorTabs = ({ timing }) => {
	const dispatch = useDispatch();
	const sliderRef = useRef(null);
	const navigate = useNavigate();
	const location = useLocation();
	const [eventfilter, setEventFilter] = useState({ query: '', companyId: 0, sort: 5, IsShowPastEvent: false, start: 1, length: 25, timezone: GetTimeZone() });
	const [filter, setFilter] = useState({ companyId: 0, userId: 0, sort: 6, timezone: GetTimeZone(), shopMonitor: true });
	const { employeeAnniversaries } = useSelector(state => state.employee);
	const { todayEventNotifications, eventsList } = useSelector(state => state.event);
	const { projectsList } = useSelector(state => state.projects);
	const [activeSlideIndex, setActiveSlideIndex] = useState(0);
	const [processedProjects, setProcessedProjects] = useState([]);
	const [allSlideUrls, setAllSlideUrls] = useState([]);
	const [vimeoToken, setVimeoToken] = useState("");
	const marketPlaceFilter = { query: '', marketPlaceTypeIds: [], sort: 6 };
	const { marketPlaceList } = useSelector(state => state.marketPlace);
	const { contestAllList } = useSelector(state => state.contest);
	const { newsList } = useSelector(state => state.news);
	const { jobPostingsListByfilter } = useSelector(state => state.hrBenefits);

	// Parse query string for modal visibility
	const params = new URLSearchParams(location.search);

	const closeModal = () => {
		params.delete('showGestureModal');
		localStorage.setItem('show_gesture_modal', false);
		globalThis.location.href = location.pathname;
	};
	
	useEffect(() => {
		if (params.get('showGestureModal') === 'true') {
			localStorage.setItem('show_gesture_modal', true);
		}

		let sharpCompanyId = localStorage.getItem('monitor_mode_company');
		if (sharpCompanyId !== undefined && sharpCompanyId !== null) {
			setFilter({ ...filter, companyId: parseInt(sharpCompanyId) });
			setEventFilter(prev => ({ ...prev, companyId: parseInt(sharpCompanyId) }));
		}
	}, []);

	useEffect(() => {
		async function fetchData() {
			await dispatch(getEmployeeWorkAnniversaries(filter));
			await dispatch(getTodayEvents(filter));
			await dispatch(getEvents(eventfilter));
			await dispatch(getMarketPlace(marketPlaceFilter));
			await dispatch(getContestList(filter));
			await dispatch(getProjects());
			await dispatch(getJobPostingsByFilter(filter));
			getVimeoToken().then((response) => {
				setVimeoToken(response.data);
			});
			await dispatch(getNews(filter));
		}
		if (filter.companyId > 0) {
			fetchData();
		}
	}, [filter, dispatch]);
	let settings = {
		dots: true,
		infinite: true,
		speed: 400,
		arrows: false,
		autoplay: true, /*change to true when completed*/
		autoplaySpeed: timing,
		variableWidth: true,
		slidesToShow: 1, // Set the number of slides to show at a time
		slidesToScroll: 1, // Set the number of slides to scroll at a time
		initialSlide: 0,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}

		]
	};

	useEffect(() => {
		const processProjects = async () => {
			const projectsWithVideoCheck = await Promise.all(
				projectsList.map(async (project) => {
					if (project.active) {
						const mediaChecks = await Promise.all(
							project.projectMedias.map(async (media) => {
								if (media.mediaItem.videoThumbnailUrl?.includes("/static/media/")) {
									return false;
								}
								if (media.mediaItem.videoType === 1) {
									return await isVimeoVideoExists(media.mediaItem.videoId, vimeoToken);
								}
								return true; // Assume images are valid
							})
						);
						const allMediaValid = mediaChecks.every(check => check === true);
						return { ...project, allMediaValid };
					}
					return { ...project, allMediaValid: false };
				})
			);
			setProcessedProjects(projectsWithVideoCheck.filter(project => project.allMediaValid));
		};

		if (projectsList && projectsList.length > 0) {
			processProjects();
		}
	}, [projectsList]);

	useEffect(() => {
		const slides = [
			{ url: "/shopmonitors/bonuslevels", type: "bonuslevel" },
			{ url: "/shopmonitors/bonus-ytd", type: "bonusYTD" },
			{ url: "/shopmonitors/financial-scoreboard", type: "financial" },
			{ url: "/shopmonitors/celebrate", type: "celebrate" },
			{ url: "/shopmonitors/welcome", type: "welcome" },
		];

		if (todayEventNotifications && todayEventNotifications.length > 0) {
			const numberOfRows = Math.ceil(todayEventNotifications.length / 5);
			for (let i = 0; i < numberOfRows; i++) {
				slides.push({ url: `/shopmonitors/today/${i}`, type: "today" });
			}
		}

		if (employeeAnniversaries && employeeAnniversaries.length > 0) {
			slides.push({ url: "/shopmonitors/anniversaries", type: "anniversaries" });
		}
		if (eventsList && eventsList.length > 0) {
			slides.push({ url: "/shopmonitors/events", type: "events" });
		}
		if (marketPlaceList && marketPlaceList.length > 0) {
			slides.push({ url: "/shopmonitors/marketplace", type: "marketplace" });
		}
		if (contestAllList && contestAllList.length > 0) {
			slides.push({ url: "/shopmonitors/contest", type: "contest" });
		}
		if (jobPostingsListByfilter && jobPostingsListByfilter.length > 0) {
			slides.push({ url: "/shopmonitors/jobpostings", type: "jobpostings" });
		}
		if (processedProjects && processedProjects.length > 0) {
			processedProjects
				.sort((a, b) => a.id - b.id)
				.forEach(project => {
					slides.push({
						url: `/shopmonitors/installed-projects/${project.id}`,
						type: "installed-projects"
					});
				});
		}
		if (newsList && newsList.length > 0) {
			newsList.forEach(news => {
				slides.push({
					url: `/shopmonitors/retirement/${news.baseId}`,
					type: "retirement"
				});
			});
		}

		setAllSlideUrls(slides);
		const initialIndex = slides.findIndex(slide => location.pathname.startsWith(slide.url));
		if (initialIndex !== -1) {
			setActiveSlideIndex(initialIndex);
		}

	}, [todayEventNotifications, employeeAnniversaries, processedProjects, getNews, location.pathname]);

	const handleSlideChange = (index) => {
		if (index >= 0 && index < allSlideUrls.length) {
			const clickedSlide = allSlideUrls[index];
			const slides = [...allSlideUrls];
			slides.splice(index, 1);
			slides.unshift(clickedSlide);
			setAllSlideUrls(slides);
			setActiveSlideIndex(index);
			navigate(clickedSlide.url);
		}
	};

	const handleSlideClick = (index) => {
		sliderRef.current.slickGoTo(index); // Programmatically move to the clicked slide
	};

	const handleNextSlide = () => {
		if (sliderRef.current) {
			sliderRef.current.slickNext();
		}
	};

	const handlePrevSlide = () => {
		if (sliderRef.current) {
			sliderRef.current.slickPrev();
		}
	};

	useEffect(() => {
		if (sliderRef.current) {
			sliderRef.current.slickGoTo(activeSlideIndex); // Ensure the Slider is on the first slide initially
		}
	}, [activeSlideIndex]);

	function getImageForSlide(type) {
		//bonusYTD 
		switch (type) {
			case "bonuslevel":
				return tab1;
			case "financial":
				return tab2;
			case "today":
				return tab3;
			case "anniversaries":
				return anniversary;
			case "events":
				return events;
			case "installed-projects":
				return tab7;
			case "bonusYTD":
				return tabYtd;
			case "marketplace":
				return tab8;
			case "contest":
				return tab9;
			case "celebrate":
				return celebrate;
			case "welcome":
				return welcome;
			case "retirement":
				return retirement;
			case "jobpostings":
				return tab10;
			default:
				return null;
		}
	}

	function getSlideName(type) {
		//bonusYTD
		switch (type) {
			case "bonuslevel":
				return "Bonus Levels";
			case "bonusYTD":
				return "Bonus Levels YTD";
			case "financial":
				return "Financial Scoreboard";
			case "today":
				return "Today";
			case "anniversaries":
				return "Anniversary";
			case "events":
				return "Events";
			case "installed-projects":
				return "Installed Projects";
			case "marketplace":
				return "Market Place";
			case "contest":
				return "Contest";
			case "celebrate":
				return "Celebrate";
			case "welcome":
				return "Welcome";
			case "retirement":
				return "Retirement";
			case "jobpostings":
				return "Job Postings";
			default:
				return null;
		}
	}

	const videoRef = useRef(null);
	const canvasRef = useRef(null);
	const gestureRecognizerRef = useRef(null);

	// Gesture recognition effect
	useEffect(() => {
		let running = true;
		let lastGesture = null;
		let lastGestureTime = 0;

		async function setupGestureRecognizer() {
			const filesetResolver = await FilesetResolver.forVisionTasks(
				// CDN path to wasm and model files
				'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm'
			);
			gestureRecognizerRef.current = await GestureRecognizer.createFromOptions(filesetResolver, {
				baseOptions: {
					modelAssetPath: 'https://storage.googleapis.com/mediapipe-assets/gesture_recognizer.task'
				},
				runningMode: 'VIDEO'
			});

			// Setup webcam
			if (navigator.mediaDevices.getUserMedia) {
				const stream = await navigator.mediaDevices.getUserMedia({ video: true });
				if (videoRef.current) {
					videoRef.current.srcObject = stream;
					videoRef.current.onloadedmetadata = () => {
						videoRef.current.play();
					};
				}
			}

			// Start processing frames
			processVideoFrame();
		}

		async function processVideoFrame() {
			if (!running || !videoRef.current || !gestureRecognizerRef.current) return;

			const video = videoRef.current;
			const canvas = canvasRef.current;

			if (video.readyState === 4) {
				const now = Date.now();
				const result = await gestureRecognizerRef.current.recognizeForVideo(video, now);

				if (result.gestures && result.gestures.length > 0) {
					const gesture = result.gestures[0][0].categoryName;

					if (localStorage.getItem('show_gesture_modal') === 'true') {
						const ctx = canvas.getContext('2d');

						// Draw video frame to canvas
						ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
						ctx.font = '32px Arial';
						ctx.fillStyle = 'rgba(255, 0, 0, 0.7)';
						ctx.fillText(`Gesture: ${gesture}`, 20, 40);

						// Optionally, draw landmarks
						if (result.landmarks && result.landmarks.length > 0) {
							ctx.strokeStyle = 'lime';
							ctx.lineWidth = 2;
							result.landmarks[0].forEach(point => {
								ctx.beginPath();
								ctx.arc(point.x * canvas.width, point.y * canvas.height, 5, 0, 2 * Math.PI);
								ctx.stroke();
							});
						}
					}

					// Gesture navigation logic
					if (gesture === 'Thumb_Down' && (lastGesture !== 'Thumb_Down' || gesture === 'Point_Left' || now - lastGestureTime > 2000)) {
						// Go backward
						handlePrevSlide();
						lastGesture = 'Thumb_Down';
						lastGestureTime = now;
					} else if (gesture === 'Thumb_Up' && (lastGesture !== 'Thumb_Up' || gesture === 'Point_Right' || now - lastGestureTime > 2000)) {
						// Go forward
						handleNextSlide();
						lastGesture = 'Thumb_Up';
						lastGestureTime = now;
					}
				}
			}
			requestAnimationFrame(processVideoFrame);
		}

		setupGestureRecognizer();

		return () => {
			running = false;
			if (videoRef.current && videoRef.current.srcObject) {
				const tracks = videoRef.current.srcObject.getTracks();
				tracks.forEach(track => track.stop());
			}
		};
	}, []);

	return (
		<nav className="monitors-nav">
			<div className="shop-monitors-tabs">
				<div className="shop-monitors-tabs-inner">
					<Slider ref={sliderRef} {...settings} afterChange={handleSlideChange}>
						{allSlideUrls && allSlideUrls.map((slide, index) => (
							<div key={`slide_${index}`}>
								<div onClick={() => handleSlideClick(index)} className={`shop-monitors-item ${activeSlideIndex === index ? 'active' : ''}`}>
									<img src={getImageForSlide(slide.type)} alt={`Tab ${index + 1}`} loading="lazy" />
									<span className="sr-only">{getSlideName(slide.type)}</span>
								</div>
							</div>
						))}
					</Slider>
				</div>
			</div>
			{/* Modal for video and canvas */}
			{localStorage.getItem('show_gesture_modal') === 'true' && (
				<div
					style={{
						position: 'fixed',
						bottom: 0,
						right: 0,
						width: 640,
						height: 480,
						zIndex: 9999,
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center'
					}}
				>
					<div style={{ position: 'relative', width: 640, height: 480, background: '#222', borderRadius: 8 }}>
						<video ref={videoRef} width={640} height={480} style={{ position: 'absolute', top: 0, left: 0 }} autoPlay muted />
						<canvas ref={canvasRef} width={640} height={480} style={{ position: 'absolute', top: 0, left: 0, pointerEvents: 'none' }} />
						<button
							type="button"
							onClick={closeModal}
							style={{
								position: 'absolute',
								top: 10,
								right: 10,
								zIndex: 2,
								background: '#fff',
								border: 'none',
								borderRadius: '50%',
								width: 32,
								height: 32,
								cursor: 'pointer',
								fontWeight: 'bold'
							}}
							aria-label="Close Gesture Modal"
						>
							X
						</button>
					</div>
				</div>
			)}
			{localStorage.getItem('show_gesture_modal') !== 'true' && (
				<video ref={videoRef} width={640} height={480} style={{ display: 'none' }} />
			)}
		</nav>
	);
};

ShopMonitorTabs.propTypes = {
	timing: PropTypes.number
};